import cx from 'classnames'
import React, { Component, useEffect } from 'react'

import Modal from '@f/components/Modal'
import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

import BudgetCalculatorModal from '@f-fertighaus/applications/BudgetCalculatorModal'
import { getUrl } from '@js/common/getUrlByDomain'

export const FinanceEntryPanel = props => {
  useEffect(() => {
    _wt({
      category: 'modal',
      action: 'display',
      values: [
        {
          type: 'name',
          value: 'finance-options'
        }
      ]
    })

    return () => {
      _wt({
        category: 'modal',
        action: 'hide',
        values: [
          {
            type: 'name',
            value: 'finance-options'
          }
        ]
      })
    }
  }, [])

  return (
    <div className='[ f-c-ba-bac025 f-p-v-060 f-p-h-020 f-c-fo-pri ] FinanceEntryPanel'>
      <CTA
        type='icon'
        tag='button'
        className='FinanceEntryPanel-close Modal-top-button Modal-top-button-close'
        data-sel='btn-cls'
        onClick={props.closeModal}>
        <Icon icon='close-16px' className='[ f-icon-030 f-c-st-bla ]' />
      </CTA>
      <div className='[ f-t-tsection f-c-fo-pri f-t-centre ]'>
        Wie können wir Ihnen helfen?
      </div>
      <div className='[ f-t-body f-m-v-020 f-t-centre ]'>
        Wählen Sie eine der unten stehenden Möglichkeiten aus oder kontaktieren
        Sie direkt einen Finanzierungsexperten.
      </div>
      <div className='FinanceEntryPanel-card-container'>
        <div className='[ f-c-ba-whi f-c-bo-pri f-p-v-030 f-p-r-020 f-m-a-010 f-pos-rel ] FinanceEntryPanel-card'>
          <Icon
            icon='sliders-16px'
            className='[ f-icon-060 f-c-st-pri f-pos-ab ] FinanceEntryPanel-icon'
          />
          <div className='[ f-t-tminor ]'>Budget-Rechner</div>
          <div className='[ f-t-body f-m-t-010 ] FinanceEntryPanel-subtitle'>
            Ermitteln Sie Ihren Budgetrahmen für das Haus ink. aller Bau- und
            Nebenkosten.
          </div>
          <CTA
            tag='a'
            type='block-secondary'
            className='[ f-m-t-030 f-p-a-020 ] is-full-width FinanceEntryPanel-cta FinanceEntryPanel-cta-secondary'
            data-sel='btn-fiop-ba'
            href={getUrl('budgetCalculator')()}>
            Budget ermitteln
          </CTA>
        </div>
        <div className='[ f-c-ba-whi f-c-bo-pri f-p-v-030 f-p-r-020 f-m-a-010 f-pos-rel ] FinanceEntryPanel-card'>
          <Icon
            icon='calculator-16px'
            className='[ f-icon-060 f-c-st-pri f-pos-ab ] FinanceEntryPanel-icon'
          />
          <div className='[ f-t-tminor ]'>Budget-Assistent</div>
          <div className='[ f-t-body f-m-t-010 ] FinanceEntryPanel-subtitle'>
            Legen Sie anhand Ihrer gewünschten Monatsrate Ihr verfügbares Budget
            fest.
          </div>
          <CTA
            tag='button'
            type='block-secondary'
            className='[ f-m-t-030 f-p-a-020 ] FinanceEntryPanel-cta FinanceEntryPanel-cta-secondary'
            data-sel='btn-fiop-bc'
            onClick={() => props.openFlow('budget_calculator')}>
            Budget festlegen
          </CTA>
        </div>
        <div className='[ f-c-ba-whi f-c-bo-pri f-p-v-030 f-p-r-020 f-m-a-010 f-pos-rel ] FinanceEntryPanel-card'>
          <Icon
            icon='handshake-64px'
            className='[ f-icon-060 f-c-st-awa f-pos-ab ] FinanceEntryPanel-icon'
          />
          <div className='[ f-t-tminor ] FinanceEntryPanel-no-break'>
            Finanzierungsanfrage
          </div>
          <div className='[ f-t-body f-m-t-010 ] FinanceEntryPanel-subtitle'>
            Lassen Sie sich persönlich von einem Finanzierungsexperten beraten.
          </div>
          <CTA
            tag='a'
            type='block-primary'
            className='[ f-m-t-030 f-p-a-020 ] FinanceEntryPanel-cta'
            data-sel='btn-fiop-fifl'
            href={getUrl('financeAssistance')()}
            wtData={{
              'CTA-click': {
                label: 'finance-quiz-standalone',
                location: 'modal-finance-options'
              }
            }}>
            Gratis Angebote einholen
          </CTA>
        </div>
      </div>
    </div>
  )
}
const isMassivhaus = location.hostname.includes('massivhaus')

export default class FinanceEntry extends Component {
  openFlow = flowType => {
    let nextModal = new Modal()

    if (flowType === 'budget_calculator') {
      nextModal.openModal({
        component: (
          <BudgetCalculatorModal
            {...window.SherlockContainer.BudgetCalculator}
          />
        )
      })
    }
  }

  openEntryModal = () => {
    let modal = new Modal()

    modal.openModal({
      component: <FinanceEntryPanel openFlow={this.openFlow} />,
      options: {
        className: 'ModalFinance'
      }
    })
  }
  render() {
    if (this.props.type === 'minimal') {
      // Search List Design
      return (
        <div className='[ f-p-v-020 ] FinanceEntry-container-minimal'>
          <div
            className={cx(
              '[ f-p-h-020 f-p-b-030 f-t-centre f-radius-card-large ] FinanceEntry FinanceEntry-minimal',
              isMassivhaus ? 'f-c-ba-sec' : 'f-c-ba-pri'
            )}>
            <div className='FinanceEntry-content FinanceEntry-content-minimal'>
              <div className='[ f-t-tsection f-c-fo-whi ]'>
                Wieviel Haus kann ich mir leisten?
              </div>
              <div className='[ f-t-body f-c-fo-whi f-m-t-020 ] FinanceEntrySubtitle FinanceEntry-subtitle-minimal'>
                Wir haben verschiedene Möglichkeiten Ihnen bei der Finanzierung
                Ihres Traumhauses zu helfen.
              </div>
              <CTA
                tag='button'
                type={isMassivhaus ? 'block-secondary' : 'block-primary'}
                className='FinanceEntry-cta-minimal'
                onClick={this.openEntryModal}>
                Budgethilfe
              </CTA>
            </div>
          </div>
        </div>
      )
    } else if (this.props.type === 'tile') {
      // CMS Category Page Design / Article Page Sidebar
      return (
        <div
          className={`[ f-m-a-0 ] FinanceEntry-wrapper ${
            this.props.extraClasses ? ` ${this.props.extraClasses}` : ''
          }`}>
          <div
            className={cx(
              '[ f-p-h-020 f-p-b-030 f-t-centre f-radius-card-large f-d-flr f-fl-al-ce ] FinanceEntry-tile',
              isMassivhaus ? 'f-c-ba-sec' : 'f-c-ba-pri'
            )}>
            <div>
              <div className='[ f-t-tsection f-c-fo-whi ]'>
                Wieviel Haus kann ich mir leisten?
              </div>
              <div className='[ f-t-body f-c-fo-whi f-m-t-020 ]'>
                Wir haben verschiedene Möglichkeiten Ihnen bei der Finanzierung
                Ihres Traumhauses zu helfen.
              </div>
              <CTA
                tag='button'
                type={isMassivhaus ? 'block-secondary' : 'block-primary'}
                className='[ f-m-t-020 f-p-a-0 ] FinanceEntry-cta-tile'
                onClick={this.openEntryModal}>
                Budgethilfe
              </CTA>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div
          className={`${
            this.props.extraClasses ? ` ${this.props.extraClasses}` : ''
          }`}>
          <div
            className={cx(
              '[ f-p-h-020 f-p-b-030 f-t-centre f-radius-card-large ] FinanceEntry',
              isMassivhaus ? 'f-c-ba-sec' : 'f-c-ba-pri'
            )}>
            <div className='FinanceEntry-content'>
              <div className='[ f-t-tsection f-c-fo-whi ]'>
                Wieviel Haus kann ich mir leisten?
              </div>
              <div className='[ f-t-body f-c-fo-whi f-m-t-020 ] FinanceEntry-subtitle'>
                Wir haben verschiedene Möglichkeiten Ihnen bei der Finanzierung
                Ihres Traumhauses zu helfen.
              </div>
              <CTA
                tag='button'
                type={isMassivhaus ? 'block-secondary' : 'block-primary'}
                className='[ f-m-t-020 f-p-a-0 ] FinanceEntry-cta'
                data-sel='bt-fiop-ep'
                onClick={this.openEntryModal}>
                Budgethilfe
              </CTA>
            </div>
          </div>
        </div>
      )
    }
  }
}
